/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {Dropdown2} from '../../content/dropdown/Dropdown2'
import moment from 'moment';
import { PDFLinkCard } from '../../content/cards/PDFLinkCard';
import { getPDFURL } from '../../../../app/modules/auth/core/_api';

type Props = {
  id: string
  class_name: string,
  title: string,
  detail: string,
  icon: string,
  pdf_file:string,
  datetime:string,
  source_parent:string,
  mid?: string | undefined | null,
  mname?: string | undefined | null,
}

const KnowledgeWidget: React.FC<Props> = ({id, class_name, title, detail, datetime, pdf_file, source_parent, mid, mname}) => {
  const truncatedText = detail.length > 100 ? detail.substring(0, 100) + '...' : detail;

  var mlink = (mid && mname)?`&mid=${mid}&mname=${mname}`:''

  return (
    <div className={`card ${class_name}`}>
      {/* begin::Body */}
      <div className='card-body pb-0'>
        {/* begin::Header */}
        <div className='d-flex align-items-center mb-3'>
          {/* begin::User */}
          <div className='d-flex align-items-center flex-grow-1'>
            {/* begin::Avatar */}
            {pdf_file && pdf_file != 'null' &&<div className='symbol symbol-45px me-5'>
               <PDFLinkCard icon='/media/svg/files/pdf.svg' title='' url={(pdf_file)?getPDFURL(pdf_file):"#"} />
            </div>}
            {/* end::Avatar */}
              
            {/* begin::Info */}
            <div className='d-flex flex-column'>
              <a href='#' className='text-gray-800 text-hover-primary fs-6 fw-bold'>
              {title}
              </a>
              <span className='text-gray-400 fw-semibold'>{datetime && moment(datetime).fromNow()}</span>
            </div>
            {/* end::Info */}
          </div>
          {/* end::User */}

          {/* begin::Menu */}
          <div className='my-0'>
          <a
              href={`/${source_parent}/kw_detail?kid=${id}${mlink}`}
              className='btn btn-sm btn-light btn-color-muted btn-active-light-success px-4 py-2 me-4'
            >
              <KTSVG path='/media/icons/duotune/communication/com012.svg' className='svg-icon-2' />
              รายละเอียด
            </a>
          </div>
          {/* end::Menu */}
        </div>
        {/* end::Header */}

        {/* begin::Post */}
        <div className='mb-7'>
          {/* begin::Text */}
          <div className='text-gray-800 mb-5'>
          {<div style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: truncatedText }} />}
          </div>
          {/* end::Text */}
        </div>
        {/* end::Post */}

      </div>
      {/* end::Body */}
    </div>
  )
}

export {KnowledgeWidget}
